import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "provider-info",
  "use": "provider-info-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"provider-info\"><path d=\"M1.625 15.375A5.627 5.627 0 019.458 10.2\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M7.25 8.5a3.437 3.437 0 100-6.875 3.437 3.437 0 000 6.875zM15.375 20.375a5 5 0 100-10 5 5 0 000 10z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M15.375 17.875v-2.5M15.375 12.875a.312.312 0 100 .625.312.312 0 000-.625\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/provider-info.svg
// module id = ejzq
// module chunks = 39 44